export const INACTIVITY_TIME_UNITS = Object.freeze({
  MINUTES: { value: 1, label: 'minutes' },
  HOURS: { value: 2, label: 'hours' },
})

export const WORK_STATION_RECORD_TYPES = Object.freeze({
  CHECK_IN: { value: 1, label: 'checkIn' },
  CHECK_OUT: { value: 2, label: 'checkOut' },
  EXPIRED_SESSION: { value: 3, label: 'expiredSession' },
  REVOKED_SESSION: { value: 4, label: 'revokedSession' },
})
